import AboutPage from '@/components/AboutPage.vue';
import HomePage from '@/components/HomePage.vue';
import DescriptionInitiativePage from '@/components/DescriptionInitiativePage.vue';
import { createRouter, createWebHistory } from 'vue-router';
import TermsConditionPage from '@/components/TermsConditionPage.vue';

const routes = [
    {
        path: '/sleephealthscreen',
        name: 'Home',
        component: HomePage,
    },
    {
        path: '/sleephealthscreen/about',
        name: 'About',
        component: AboutPage,
    },
    {
        path: '/sleephealthscreen/description-initiative',
        name: 'DescriptionInitiative',
        component: DescriptionInitiativePage,
    },
    {
        path: '/sleephealthscreen/terms-condition',
        name: 'TermsCondition',
        component: TermsConditionPage,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
});

export default router;
